import { ChangeEvent } from 'react';
import React from 'react';
import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import ReportCollection from '../models/ReportCollection';
import ReportModel from '../models/ReportModel';
import { i18n } from '@mabinso-registry/module-commons';
import { MabDialogDefault, Button, MabDialogUpload, Typography } from '@mabinso-registry/mabinso-universal';
import ReportCategoryModel from '../models/ReportCategoryModel';
import ConfirmView from '../../app/views/ConfirmView';
import ReportView from './ReportView';
import { createRoot } from 'react-dom/client';
import EditCategoryView from './EditReportCategoryView';
import html from '../templates/report_category_view.template?raw';
import Globals from '../../../utils/Globals';
import { NavigateFunction } from 'react-router';

interface BackboneView extends Backbone.View {
    options: any;
}

interface BackboneView2 extends Backbone.View {
    options: any;
    onlyone: Function;
}

interface ViewOptions extends Backbone.ViewOptions<ReportCategoryModel> {
    afterRender: Function;
    enableHelp: Function;
    editReportView?: BackboneView;
    reportListView: BackboneView2;
    navigate: NavigateFunction;
    search: any;
    maxRows: number;
}

class ReportCategoryView extends Backbone.View<ReportCategoryModel> {
    static events: Backbone.EventsHash = {
        'click .typbeschriftung.hasReports .opentype.active': 'closeReports',
        'click .typbeschriftung.hasReports .opentype:not(.active)': 'openReports',
        'click .deleteCategory': 'deleteCategory',
        'click .editCategory': 'editCategory',
        'click .addReport': 'addReport',
        'click .buttonsammlung_reportzeilen .listSelector': 'toggleSelectReportAllSaved',
        'click .typbeschriftung .listSelector': 'toggleSelectReportAllCategory',
    };
    constructor(options: ViewOptions) {
        options.events = ReportCategoryView.events;
        super(options);
        this.reportViews = [];
        this.options = options;
    }
    options: ViewOptions;
    reportViews: any;
    render() {
        const report = new ReportCollection();
        const view = this;
        const tstring = _.template(html);
        view.$el.html(tstring({ reportcategory: view.model, $, Actions: Globals.actions }));
        view.$el.find('.waitreport').pnganimation('init', { time: 50 });
        view.renderTemplateSuccess();
        const reports = view.model.get('reports');
        if (reports) {
            console.log('get from model', reports);
            if (reports.length > 0) {
                view.setReportsCount(reports.length);
                view.categoryHasReports(true);
                reports.forEach((data: any) => {
                    var model = new ReportModel(data);
                    view.addReportView(model, () => {});
                    report.add(model);
                });
                view.collection = report;
            } else {
                view.categoryHasReports(false);
            }
            view.options.afterRender();
        } else {
            report.fetch({
                data: { report_category_id: view.model.id, ...view.options.search },
                success(collection: any) {
                    if (collection.length > 0) {
                        view.setReportsCount(collection.length);
                        view.categoryHasReports(true);
                        collection.each((model: any) => {
                            view.addReportView(model, () => {});
                        }, view.options.afterRender);
                        view.collection = collection;
                    } else {
                        view.categoryHasReports(false);
                        view.options.afterRender();
                    }
                },
            });
        }
        report.sortByField('name', 'asc');
        return view;
    }
    addReportView(model: any, callback?: () => void) {
        const view = this;
        const el = _.make('div', {
            id: 'reportvorlage' + model.id,
            'data-id': model.id,
            class: 'reportvorlage',
        });
        view.$('.reportvorlagensammlung').append(el);
        const reportView = new ReportView({
            el,
            model,
            reportCategoryView: view,
            navigate: view.options.navigate,
            afterRender: callback,
            enableHelp: view.options.enableHelp,
            search: view.options.search,
            maxRows: view.options.maxRows,
        });
        model.view = reportView;
        view.reportViews.push(reportView);
        reportView.render();
    }
    renderTemplateSuccess() {}
    addReportsSavedCount(count: number, countNew: number) {
        const oldCounts = this.getReportsSavedCount();
        count = oldCounts.count + count;
        countNew = oldCounts.countNew + countNew;
        this.setReportsSavedCount(count, countNew);
        if (_.size(this.reportViews) > 0) {
            this.categoryHasReports(true);
        } else {
            this.categoryHasReports(false);
        }
    }
    getReportsSavedCount() {
        return {
            count: parseInt(this.$('.reportsSaved-count').html(), 10),
            countNew: parseInt(this.$('.reportsSavedNew-count').html(), 10),
        };
    }
    setReportsSavedCount(count: number, countNew: number) {
        this.$('.reportsSaved-count').html(count.toString());
        this.$('.reportsSavedNew-count').html(countNew.toString());
    }
    setReportsCount(count: number) {
        this.$('.reports-count').html(count.toString());
    }
    categoryHasReports(value: boolean) {
        if (value) {
            this.$el.show();
            this.$('.typbeschriftung .waitreport').pnganimation('stop', { left: -915, top: -205 });
            this.$('.typbeschriftung .waitreport').addClass('noreport').removeClass('waitreport');
            this.$('.typbeschriftung').addClass('hasReports');
            // Es gibt mindestens eine Sammlung, die weitere Unterpunkte enthält. Die Mathode zum öffnen, wenn es nur einen gibt wird der aufgeklappt
            this.options.reportListView.onlyone();
        } else {
            // this.$el.hide();
            // this.$('.typbeschriftung').removeClass('hasReports');

            this.$('.typbeschriftung .waitreport').pnganimation('stop', { left: -915, top: -205 });
            this.$('.typbeschriftung .waitreport').removeClass('waitreport').addClass('noreport').addClass('sprites_main');
        }
    }
    triggerReports(open: boolean) {
        const opener = this.$('.typbeschriftung .opentype');
        if (_.isUndefined(open)) {
            opener.trigger('click');
        } else {
            if (open && !opener.hasClass('active')) {
                opener.trigger('click');
            }
            if (!open && opener.hasClass('active')) {
                opener.trigger('click');
            }
        }
    }

    toggleSelectReportAllSaved(e: ChangeEvent<HTMLInputElement>) {
        const view = this;
        if ($(e.target).hasClass('true')) {
            view.updateSelectStatusReportcategory($(e.target).closest('.reportvorlage'), 'true');
        } else {
            view.updateSelectStatusReportcategory($(e.target).closest('.reportvorlage'), 'false');
        }
        return false;
    }
    toggleSelectReportAllCategory(e: ChangeEvent<HTMLInputElement>) {
        const view = this;
        if ($(e.target).hasClass('true')) {
            view.updateSelectStatusReportcategory($(e.target).closest('.reportcategory'), 'true');
        } else {
            view.updateSelectStatusReportcategory($(e.target).closest('.reportcategory'), 'false');
        }
        return false;
    }
    updateSelectStatusReportcategory(vorlage: any, status: string) {
        if (status === 'true') {
            vorlage.find('.reports .listSelector.true').trigger('click');
        } else {
            vorlage.find('.reports .listSelector.false').trigger('click');
        }
        return false;
    }
    addReport(evt) {
        const view = this;
        const container = document.getElementById('uploadDialog');
        const root = createRoot(container);
    
        root.render(
            <MabDialogUpload
                open
                accept=".jrxml"
                cancel={() => {
                    root.unmount();
                }}
                confirm={(data) => {
                    const reportModel = new ReportModel();
                    reportModel.uploadReportFetch({
                        id: view.model.id,
                        file: data.files.file,
                        success: (message: any) => {root.unmount(); view.uploadSuccess(message);},
                        error: (err: any) => {root.unmount(); view.uploadError(err);}
                    });
                }}
            />
        );
    }
    uploadSuccess(message) {
        const view = this;
        const container = document.getElementById('uploadDialog');
        const root = createRoot(container);

        const closeAction = () => {
            root.unmount();
            view.options.reportListView.render();
        };

        const actions = () => {
            return <Button data-cy="ButtonClose" variant="contained" onClick={closeAction}><>{i18n.t('modal.button.close')}</></Button>;
        };
        root.render(
            <MabDialogDefault maxWidth="sm" closeAction={closeAction} actions={(actions())} title={i18n.t('alert.action.success')}>
                <Typography variant="body1"   dangerouslySetInnerHTML={{ __html: message.success[0].message }} />
            </MabDialogDefault>
        );
    }
    uploadError(err) {
        const view = this;
        const container = document.getElementById('uploadDialog');
        const root = createRoot(container);
        const actions = () => {
            return <Button data-cy="ButtonClose" variant="contained" onClick={() => {root.unmount();}}><>{i18n.t('modal.button.close')}</></Button>;
        };
        console.log('err', err);
        root.render(
            <MabDialogDefault maxWidth="sm" closeAction={() => {root.unmount();}} actions={(actions())} title={i18n.t('alert.action.nosuccess')}>
                <Typography variant="body1">{err}</Typography>
            </MabDialogDefault>
        );
    }
    editCategory() {
        const view = this;
        if (_.isUndefined(view.options.reportListView.options.editReportCategoryView)) {
            view.options.reportListView.options.editReportCategoryView = new EditCategoryView({
                reportListView: view.options.reportListView,
            });
        }
        view.options.reportListView.options.editReportCategoryView.model = view.model;
        view.options.reportListView.options.editReportCategoryView.render();
    }
    deleteCategory() {
        const view = this;
        ConfirmView.show({
            message: $._('report.alert.reportcategory.confirm.delete'),
            title: $._('alert.action.delete'),
            yesString: $._('alert.action.delete'),
            yesFunc() {
                view.model.destroy({
                    success() {
                        view.options.reportListView.render();
                    },
                });
            },
        });
    }
    openReports(evt: ChangeEvent<HTMLInputElement>) {
        const view = this;
        const root = $(evt.target).closest('.reportcategory');
        $('.typinfo_outer', root).fadeOut('fast', () => {
            $('.reportvorlagensammlung', root).slideDown('fast');
            $('.typbeschriftung', root).addClass('active');
            $(evt.target).addClass('active');
            if (window.scroll) {
                // eslint-disable-next-line dot-notation
                // $.scrollTo($('.typbeschriftung', root).offset()!.top - 213, 200); // Herausgenommen wegen https://mabinso.atlassian.net/browse/MABINSO-2831
            }
        });
    }
    closeReports(evt: ChangeEvent<HTMLInputElement>) {
        const root = $(evt.target).closest('.reportcategory');
        $('.reportvorlagensammlung', root).slideUp('fast', () => {
            $('.typinfo_outer', root).fadeIn('fast');
            $('.typbeschriftung', root).removeClass('active');
            $(evt.target).removeClass('active');
        });
    }
}

export default ReportCategoryView;
